import { createContext } from "react";

// This React context provider will give us access to the root element that
// the React app is attached to.
const context = createContext<HTMLElement | null>(null);

export const RootProvider = context.Provider;
export const RootConsumer = context.Consumer;
export default context;
